import { useQuery } from "@apollo/client";
import { useStyletron } from "baseui";
import { Tag } from "containers/Tags/tags";
import { TAGS_SELECT } from "containers/Tags/tags.gql";
import { useAuth } from "contexts/auth-context";
import React from "react";
import { Controller, UseControllerProps } from "react-hook-form";
import { Ban } from "tabler-icons-react";
import { PERMISSIONS } from "utils/permissions";

import Select, { SelectWithActiveProjectProps } from "./select";

export default function ControlledTagsSelect({
  control,
  disabled,
  name,
  rules,
  activeProjectId,
  ...rest
}: // eslint-disable-next-line @typescript-eslint/no-explicit-any
UseControllerProps<any> & SelectWithActiveProjectProps): React.ReactElement {
  const { checkPermission } = useAuth();
  const [css] = useStyletron();

  const { data, loading } = useQuery(TAGS_SELECT, {
    variables: {
      ...(activeProjectId && {
        filter: {
          projectId: {
            eq: activeProjectId,
          },
        },
      }),
    },
  });

  const hasPermission = checkPermission(PERMISSIONS.tag.read);

  return (
    <Controller
      control={control}
      name={name}
      rules={rules}
      render={({ field: { onChange, onBlur, value, name } }) => (
        <Select
          id={name}
          options={data?.tags?.nodes?.map(({ id, name }: Tag) => ({
            id,
            label: name,
          }))}
          placeholder={
            hasPermission ? (
              "Wybierz"
            ) : (
              <div
                className={css({
                  display: "flex",
                  alignItems: "center",
                  gap: " 5px",
                })}
              >
                <Ban size={16} />
                Brak uprawnień do przeglądania tagów
              </div>
            )
          }
          disabled={disabled || !hasPermission}
          isLoading={loading}
          onChange={(params) => params && onChange(params.value)}
          onBlur={onBlur}
          multi
          {...(data && { value: value })}
          {...rest}
        />
      )}
    />
  );
}
